import { Card, CardContent, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { FormProvider, useForm } from "react-hook-form";
import WSPhone from "../../Components/Phone/WSPhone";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { GstAddress } from "./GstAddress";
import { CreditBalance } from "./CreditBalance";
import { AdditionalFields } from "./AdditionalFields";
import { useNavigate, useParams } from "react-router-dom";
import WSButton from "../../Components/Button/WSButton";

export const Party: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm<any>();
  const { tab } = useParams();
  const tabNum = Number(tab) || 0;
  const navigate = useNavigate();
  const methods = useForm();
  const tabsData: any[] = [
    { label: "GST & Address", content: <GstAddress /> },
    { label: "Credit & Balance", content: <CreditBalance /> },
    { label: "Additional Fields", content: <AdditionalFields /> },
  ];
  const [loading, setLoading] = useState(false);
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);

  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleDataSaveAndNew = () => {};
  const handleClose = () => {
    navigate("/");
  };
  return (
    <>
      <form>
        <Card>
          <CardContent>
               <Grid container alignItems="center" justifyContent="space-between" wrap="nowrap" >
                          <Grid container spacing={2} alignItems="center" wrap="nowrap">
                            <Grid item>
                              <Typography fontWeight="bold" variant="h6">
                                Add Party
                              </Typography>
                            </Grid>
            
                          </Grid>
            
                        {/* Right side: Close Icon */}
                        <Grid item>
                          <IconButton onClick={handleClose}>
                            <WSIcons.CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>

                      
            <Grid container spacing={2} mt={2}>
           
              <Grid item xs={12} sm={4}>
                <WSTextField
                  label={"Party Name *"}
                  {...register("partyName")}
                  id="partyName"
                  name="partyName"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <WSTextField
                  label={"GSTIN"}
                  {...register("gstIn")}
                  id="gstIn"
                  name="gstIn"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <WSPhone
                  label={"Phone Number"}
                  id={"phoneNumber"}
                  name={"phoneNumber"}
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <WSTabs
                  id="partTab"
                  setValue={setValue}
                  control={control}
                  name="partTab"
                  tabs={tabsData}
                  selectedTab={tabNum}
                  justifyTabs="flex-start"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save & New"
              size="medium"
              variant="outlined"
              color="primary"
              onClick={handleSubmit(handleDataSaveAndNew)}
              loading={loadingSaveAndNew}
              sx={{
                borderRadius: 2,
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "rgba(126, 176, 246, 1)",
                backgroundColor: "#FFFFFF",
              }}
            />
          </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                borderRadius: 2,
                width: "6rem",
                border: "1px solid rgba(126, 176, 246, 1)",
                color: "#FFFFFF",
                backgroundColor: "rgba(126, 176, 246, 1)",
                "&:hover": {
                  backgroundColor: "rgba(126, 176, 246, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </>
  );
});
